<template>
        <v-data-table dense :headers="headers" :items="allpayments" :search="search" sort-by="dod" class="elevation-1" show-select>
            <template v-slot:top>
            <v-toolbar flat color="white">
                <v-dialog v-model="dialog" max-width="500px">
                    <template v-slot:activator="{ on }">
                       <!--  <v-icon large class="mdi mdi-plus-circle" v-on="on"></v-icon> -->
                    </template>
                    <v-card>
                        <v-card-title>
                        <span class="headline">{{ formTitle }}</span>
                        </v-card-title>
                        <v-card-text>
                        <v-container>
                            <v-row>
                            <v-col cols="12" sm="6" md="4" v-for="header in headers" :key="header.value">
                                <v-text-field v-if="header.value != 'action'" v-model="editedItem[header.value]" :label="header.text"></v-text-field>
                            </v-col>
                            </v-row>
                        </v-container>
                        </v-card-text>

                        <v-card-actions>
                        <div class="flex-grow-1"></div>
                        <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
                        <v-btn color="blue darken-1" text @click="save">Save</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
                
                  <template>
                    <v-icon large class="mdi mdi-printer" @click=""></v-icon>
                    <v-icon large class="mdi mdi-email" @click=""></v-icon>
                  </template>
                  <div class="flex-grow-1"></div>
                  <v-text-field v-model="search" append-icon="mdi mdi-magnify" label="Search" single-line hide-details></v-text-field>
            </v-toolbar>
            </template>
            <template v-slot:item.action="{ item }">
                <v-icon small class="mdi mdi-border-color" @click="editItem(item)"></v-icon>
                <v-icon small class="mdi mdi-printer" @click=""></v-icon>
                <v-icon small class="mdi mdi-eye" @click=""></v-icon>
                <v-icon small class="mdi mdi-email" @click=""></v-icon>
            </template>
            <template v-slot:no-data>
                <v-btn color="primary" @click="initialize">Reset</v-btn>
            </template>
        </v-data-table>
</template>
<script>
export default {
    name: 'AllPaymentsDataTable',
    data: () => ({
      selected: [],
      dialog: false,
      show: false,
      search: '',
      headers: [
        {
          text: 'Vessel',
          align: 'left',
          sortable: false,
          value: 'vessel_name',
        },
        { text: 'Voyage no', value: 'voyage_no' },
        { text: 'DOA', value: 'doa' },
        { text: 'DOD', value: 'dod' },
        { text: 'Days Spent', value: 'days_spent' },
        { text: 'Current Charges (€)', value: 'current_charges'},
        { text: 'Total Charges (€)', value: 'total_charges' },
        { text: 'Actions', value: 'action', sortable: false },
      ],
      allpayments: [],
      editedIndex: -1,
      editedItem: {
        vessel_name: '',
        voyage_no: '',
        doa: '',
        dod: '',
        days_spent: '',
        current_charges: '',
        total_charges: '',
      },
      defaultItem: {
        vessel_name: '',
        voyage_no: '',
        doa: '',
        dod: '',
        days_spent: 0,
        current_charges: 0.0,
        total_charges: 0.0,
      },
    }),

    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'New Payment' : 'Edit Payment'
      },
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
    },

    created () {
      this.initialize()
    },

    methods: {
      initialize () {
        this.allpayments = [
            {vessel_name: 'Vessel 1', voyage_no: 'HHD099', doa: '12/01/2020', dod: '12/02/2020', days_spent:'0', current_charges: 887, total_charges: 9778.87}, 
            {vessel_name: 'Vessel 2' , voyage_no: 'KDDH988', doa: '12/01/2020', dod: '12/02/2020', days_spent:'0', current_charges: 6789, total_charges: 876.00},
            {vessel_name: 'Vessel 3', voyage_no: '988KKS9', doa: '12/01/2020', dod: '12/02/2020', days_spent:'0', current_charges: 887668, total_charges: 9000.00}
            ]
      },

      editItem (item) {
        this.editedIndex = this.allpayments.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },

      close () {
        this.dialog = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },

      save () {
        if (this.editedIndex > -1) {
          Object.assign(this.allpayments[this.editedIndex], this.editedItem)
        } else {
          this.allpayments.push(this.editedItem)
        }
        this.close()
      },
    },
}
</script>